export default __webpack_public_path__ + "static/media/inlab-card.99c4ce03.svg";